import { Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CrearNotificacionDestinatario, Destinatario, NotificacionDestinatarioService } from '../../../../shared/services/notificacion-destinatario.service';
declare var require: any;
const Swal = require('sweetalert2');

@Component({
  selector: 'app-configuracion-notificaciones',
  templateUrl: './configuracion-notificaciones.component.html',
  styleUrls: ['./configuracion-notificaciones.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfiguracionNotificacionesComponent implements OnInit {
  mostrarFormulario = false;

  errorModal: any;
  error: any;
  destinatarios: any[] = [];
  destinatarioSeleccionado: any = null;
  cargando = false;
  filtrar = '';
  busqueda = '';
  notificacionesHabilitadas = false;
  activos = false;
  form!: FormGroup;
  mensaje = '';
  formulario!: FormGroup;
  editandoId: any = null;
  destinatarioEditando: Destinatario | null = null;
  constructor(
    private NotificacionDestinatarioService: NotificacionDestinatarioService,
    private fb: FormBuilder) {
    this.formulario = this.fb.group({
      nombre: ['', [
        Validators.required,
        Validators.maxLength(150)
      ]],
      correo: ['', [
        Validators.required,
        Validators.email,
        Validators.maxLength(254)
      ]],
      recibir_vehiculos: [true],
      recibir_conductores: [true],
      notificar_vencidos: [true],
      activo: [true]
    });

    this.formulario.valueChanges.subscribe(() => {
      this.errorModal = '';
    });
  }


  ngOnInit(): void {
    // throw new Error('Method not implemented.');
    this.listarDestinatarios();
  }

  nuevo(): void {
    console.log('Click en Nuevo destinatario');

    this.errorModal = '';
    this.editandoId = null;

    this.formulario.reset({
      nombre: '',
      correo: '',
      recibir_vehiculos: true,
      recibir_conductores: true,
      notificar_vencidos: true,
      activo: true
    });

    this.mostrarFormulario = true;

    console.log('mostrarFormulario:', this.mostrarFormulario);
  }

  //función para cancelar el formulario
  cancelar(): void {
    this.mostrarFormulario = false;
    this.editandoId = null;
  }

  validarCorreo(correo: string): boolean {
    if (!correo) {
      return false;
    }

    const email = correo.trim();

    if (email.length > 254) {
      return false;
    }

    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

    return regex.test(email);
  }

guardar(): void {
  this.formulario.markAllAsTouched();

  if (this.formulario.invalid) {
    return;
  }

  const correo = this.formulario
    .get('correo')
    ?.value?.trim();

  if (!this.validarCorreo(correo)) {
    this.errorModal = 'Ingresa un correo electrónico válido.';
    return;
  }

  this.errorModal = '';

  const datos = {
    ...this.formulario.getRawValue(),
    correo
  };

  this.guardarDestinatario(datos);
}

  get destinatariosFiltrados(): Destinatario[] {
    return this.destinatarios || [];
  }

  //para llamar el servicio y guardar el destinatario
 guardarDestinatario(datos: Partial<Destinatario>): void {
  const esEdicion = this.editandoId !== null;
const datosnew = {
  nombre: this.formulario.get('nombre')?.value as string,
  correo: this.formulario.get('correo')?.value as string,
  recibir_vehiculos: this.formulario.get('recibir_vehiculos')?.value as boolean,
  recibir_conductores: this.formulario.get('recibir_conductores')?.value as boolean,
  notificar_vencidos: this.formulario.get('notificar_vencidos')?.value as boolean,
  activo: this.formulario.get('activo')?.value as boolean
};
  const solicitud = esEdicion
    ? this.NotificacionDestinatarioService.actualizar(
        this.editandoId,
        datos
      )
    : this.NotificacionDestinatarioService.crear(datosnew);

  solicitud.subscribe({
    next: (respuesta) => {
      if (respuesta?.codigo === 0) {
        this.mostrarFormulario = false;
        this.editandoId = null;
        this.destinatarioEditando = null;

        this.formulario.reset({
          nombre: '',
          correo: '',
          recibir_vehiculos: true,
          recibir_conductores: true,
          notificar_vencidos: true,
          activo: true
        });

        this.listarDestinatarios();

        Swal.fire({
          icon: 'success',
          title: esEdicion
            ? 'Destinatario actualizado'
            : 'Destinatario creado',
          text: esEdicion
            ? 'Los cambios se guardaron correctamente.'
            : 'El destinatario se creó correctamente.'
        });
      } else {
        this.errorModal =
          respuesta?.mensaje || 'No fue posible guardar el destinatario.';
      }
    },
    error: (error) => {
      console.error('Error al guardar destinatario:', error);

      this.errorModal =
        error?.error?.mensaje ||
        'Ocurrió un error al guardar el destinatario.';
    }
  });
}


  listarDestinatarios(): void {
    this.cargando = true;

    this.NotificacionDestinatarioService.listar().subscribe({
      next: (respuesta) => {
        console.log('Destinatarios listados:', respuesta);

        if (respuesta?.codigo === 0) {
          this.destinatarios = Array.isArray(respuesta.datos)
            ? respuesta.datos
            : [];
        } else {
          this.destinatarios = [];
          console.error(
            'No fue posible listar los destinatarios:',
            respuesta?.mensaje
          );
        }

        this.cargando = false;
      },
      error: (error) => {
        console.error('Error al listar destinatarios:', error);
        this.destinatarios = [];
        this.cargando = false;
      }
    });
  }
 editar(destinatario: Destinatario): void {
  this.destinatarioEditando = destinatario;
  this.editandoId = destinatario.id;
  this.errorModal = '';

  this.formulario.patchValue({
    nombre: destinatario.nombre,
    correo: destinatario.correo,
    recibir_vehiculos: destinatario.recibir_vehiculos,
    recibir_conductores: destinatario.recibir_conductores,
    notificar_vencidos: destinatario.notificar_vencidos,
    activo: destinatario.activo
  });

  this.mostrarFormulario = true;
}
get totalDestinatariosActivos(): number {
  return this.destinatarios.filter(d => d.activo === true).length;
}
get totalDestinatariosConAlertas(): number {
  return this.destinatarios.filter(d => d.notificar_vencidos === true).length;
}
}
